import React, { useState, useEffect } from 'react';
import { Fireworks } from 'fireworks/lib/react';
import { colors } from '@hydra/common/styles';

interface Config {
  count: number;
  interval: number;
  colors: string[];
  x: number;
  y: number;
  particleTimeout: number;
  bubbleSizeMaximum: number;
}

const FireworksComponent = ({ circleRef }: { circleRef: React.RefObject<any> }) => {
  const [unMount, setUnMount] = useState(false);
  const [config, setConfig] = useState<Config | null>(null);

  useEffect(() => {
    const fxProps = {
      count: 4,
      interval: 2000,
      colors: [
        colors.success.medium,
        colors.success.main,
        colors.success.light
      ],
      x: circleRef.current.clientWidth / 4,
      y: circleRef.current.clientHeight / 4,
      particleTimeout: 2000,
      bubbleSizeMaximum: 20
    };
    setConfig(fxProps);

    const timeout = setTimeout(() => {
      setUnMount(true);
    }, 2000); // end animation after first interval
    return () => clearTimeout(timeout);
  }, [circleRef]);

  if (config === null || unMount) {
    return null;
  }

  return <Fireworks {...config} />;
};

export default FireworksComponent;
